export default __webpack_public_path__ + "static/media/webpay_payment.ad0a00af.png";